"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStepTwoLayout = exports.SessionStepOneLayout = void 0;
const core_1 = require("@emotion/core");
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SessionStepOneLayout = ({ type, onContinue, hasCaregiver, }) => (core_1.jsx("div", { className: styles_scss_1.default.sessionLayout },
    core_1.jsx("div", { className: styles_scss_1.default.header },
        core_1.jsx("img", { src: constants_1.Images.orangeCalendar, alt: "calendar" }),
        core_1.jsx("h3", null, constants_1.default.program.bookSessionType[type])),
    !hasCaregiver ? (core_1.jsx("div", { className: styles_scss_1.default.noTherapistCont },
        core_1.jsx("img", { src: constants_1.Images.undrawCoWorkers, alt: "no-therapist" }),
        core_1.jsx("h2", null, constants_1.default.program.noOneAssigned[type]),
        core_1.jsx("p", null, constants_1.default.program.tryAgainLater),
        core_1.jsx(components_1.Button, { className: styles_scss_1.default.noTherapistBtn, title: constants_1.default.program.done, ariaLabel: constants_1.default.program.done, onClick: onContinue, variant: "secondary" }))) : (core_1.jsx(react_1.default.Fragment, null,
        core_1.jsx("div", { className: styles_scss_1.default.content },
            core_1.jsx("label", null, constants_1.default.program.youHaveDoneAGreatJob),
            core_1.jsx("p", { className: styles_scss_1.default.paragraph }, constants_1.default.program.timeToBook[type]),
            core_1.jsx(components_1.Banner, { backgroundColor: styles_scss_1.default.primary01, description: constants_1.default.program.cantContinue, borderRadius: "5px", icon: constants_1.Images.bannerInfoIcon })),
        core_1.jsx(components_1.Button, { className: styles_scss_1.default.continueBtn, title: constants_1.default.program.iUnderstand, ariaLabel: constants_1.default.program.iUnderstand, onClick: onContinue })))));
exports.SessionStepOneLayout = SessionStepOneLayout;
const bookingiFrame = (url) => `<meta name="viewport" content="width=device-width, initial-scale=1"><iframe src='${url}' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>`;
const SessionStepTwoLayout = ({ type, caregiver, onContinue, }) => (core_1.jsx("div", { className: styles_scss_1.default.sessionLayout },
    core_1.jsx("div", { className: styles_scss_1.default.header },
        core_1.jsx("img", { src: constants_1.Images.orangeCalendar, alt: "calendar" }),
        core_1.jsx("h3", null, constants_1.default.program.bookSessionType[type])),
    core_1.jsx("div", { className: styles_scss_1.default.content },
        core_1.jsx("label", { className: styles_scss_1.default.contentLabel }, constants_1.default.program.info[type]),
        core_1.jsx("p", null,
            core_1.jsx("strong", null, constants_1.default.program.name),
            caregiver.name),
        core_1.jsx("p", null,
            core_1.jsx("strong", null, constants_1.default.program.email),
            caregiver.email),
        core_1.jsx("p", null,
            core_1.jsx("strong", null, constants_1.default.program.phone),
            caregiver.formattedPhone),
        core_1.jsx("p", null,
            core_1.jsx("strong", null, constants_1.default.program.meetingLink),
            core_1.jsx(components_1.Anchor, { label: caregiver.meetingUrl, path: caregiver.meetingUrl })),
        core_1.jsx("div", { className: styles_scss_1.default.iframe, dangerouslySetInnerHTML: { __html: bookingiFrame(caregiver.microsoftUrl) } })),
    core_1.jsx(components_1.Button, { className: styles_scss_1.default.continueBtn, title: constants_1.default.program.finish, ariaLabel: constants_1.default.program.finish, onClick: onContinue })));
exports.SessionStepTwoLayout = SessionStepTwoLayout;
